import React from 'react';
import Grid from '../../../components/Grid/Grid';

export default (props) => {
    const {
        adobeAudience,
        automationId,
        backgroundColor,
        column,
        description,
        deviceType,
        disclaimer,
        featureFlags,
        gridStyle,
        hasBorder,
        headline,
        irisComponentsWithoutGrid,
        items,
        largeMedia,
        mediumMedia,
        pageType,
        preferences,
        primaryLink,
        seeDetailsLink,
        smallMedia,
        style,
    } = props;
    return (
        <Grid
            adobeAudience={adobeAudience}
            automationId={automationId || 'grid-component'}
            backgroundColorGrid={backgroundColor}
            description={description}
            deviceType={deviceType}
            disclaimer={disclaimer}
            featureFlags={featureFlags}
            gridStyle={gridStyle}
            hasBorder={hasBorder}
            headline={headline}
            irisComponents={irisComponentsWithoutGrid || []}
            items={items}
            largeMedia={largeMedia}
            mediumMedia={mediumMedia}
            numberOfColumns={column}
            pageType={pageType}
            preferences={preferences}
            primaryLink={primaryLink}
            scrollable={style}
            seeDetailsLink={seeDetailsLink}
            smallMedia={smallMedia}
        />
    );
};
